import React from "react";
import { NavLink } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LIVE_ACCOUNT_URL } from "../../lib/api";
import { navLinks } from "./navLinks";

export default function MobileMenu() {
    return (
        <div className="md:hidden border-t border-white/5 bg-[#050814]/95 backdrop-blur-xl">
            <div className="xpo-container py-4 flex flex-col gap-3">
                {navLinks.map((l) => (
                    <NavLink
                        key={l.to}
                        to={l.to}
                        end={l.to === "/"}
                        data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                        className={({ isActive }) =>
                            `py-2 text-base font-semibold ${
                                isActive ? "text-[#A6E3DC]" : "text-slate-300"
                            }`
                        }
                    >
                        {l.label}
                    </NavLink>
                ))}
                <a
                    href={LIVE_ACCOUNT_URL}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="nav-mobile-cta-open-account"
                    className="btn-primary mt-2 justify-center"
                >
                    Open Account <ArrowUpRight size={16} />
                </a>
            </div>
        </div>
    );
}
